var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import OptionPicker from "../../OptionPicker";
import SetBrand from "./SetBrand";
import { isDefaultBrand, resetBrand } from "../../../helpers";
import BrandPreview, { PreviewVariants } from "./BrandPreview";
var Brand = /** @class */ (function (_super) {
    __extends(Brand, _super);
    function Brand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionData = [
            {
                selectionId: 1,
                title: "setup_tenant.steps.brand.options.custom.title",
                description: "setup_tenant.steps.brand.options.custom.description",
                actionRequiredForStepCompletion: true,
                component: React.createElement(SetBrand, { isDefaultBrand: isDefaultBrand, setIsStepCompletable: _this.props.setIsStepCompletable })
            },
            {
                selectionId: 2,
                title: "setup_tenant.steps.brand.options.usePerkbox.title",
                description: "setup_tenant.steps.brand.options.usePerkbox.description",
                actionRequiredForStepCompletion: false,
                component: React.createElement(BrandPreview, { variant: PreviewVariants.Default })
            }
        ];
        return _this;
    }
    Brand.prototype.render = function () {
        var _a = this.props, existingSelectionId = _a.existingSelectionId, handleOptionChange = _a.handleOptionChange, setIsStepCompletable = _a.setIsStepCompletable;
        return (React.createElement(OptionPicker, { options: this.optionData, existingSelectionId: existingSelectionId, handleOptionChange: handleOptionChange, setIsStepCompletable: setIsStepCompletable, areStepSettingsDefault: isDefaultBrand, resetToDefault: resetBrand }));
    };
    return Brand;
}(PureComponent));
export default Brand;
